export default function normalizeDate(value: string): Moment | null {

    if (value) {
        const newMoment: Moment = momentDate(value)
        if (newMoment.isValid()) return newMoment
    }

    return null
}